export default {
    name: 'ILayoutHeader'
};
